<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <h5 class="title t-apply"></h5>
                    <div class="msg-view">
                        <div class="text">请确认是否接受来自<b>{{ player_data.nickName }}</b>的结义邀请</div> 
                    </div>

                    <div class="warn">可申请多个，但只能加入一个结义小队，请仔细确认</div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    position: relative;
    //width: 528px;
    // height: 308px;
    // background-image: url(~@/assets/images/modal/bg-modal-msg.png);   
}

.t-apply{
    width: 516px;
    height: 51px;
    margin: 0 auto 32px;
    background-image: url(~@/assets/images/modal/title-apply.png);      
}

.msg-view{
    text-align: center;
    margin: 0 auto 0;
    padding: 0 20px;

    color: #725132;
    line-height: 1.8;

    b{
        padding: 0 10px;
        color: #d16443;
    }
}

.warn{
    font-size: 18px;
    text-align: center;
    color: #a09390;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 60px;
}

.u-btn.ok{
    width: 266px;
    height: 69px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 266px;
    height: 69px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiInviteApply , apiInviteInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码    
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.render();
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                      
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiInviteApply({ code : this.code }).then(
                res => {
                    this.destroyElement();
                    this.$msg_modal({type : 'success-apply' ,text : '请耐心等待队长<b>'+ this.player_data.nickName +'</b> 在【申请列表】确认！'})
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                   
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '该用户累计加入次数已达上限' : rej.message;
                    //this.$toast(error);
                    this.$msg_modal({type : 'error-apply' ,text : rej.message});
                    
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       
                },
            );
        },                
    },
}
</script>